import { Total } from './total';
var Price = /** @class */ (function () {
    function Price(price) {
        this.total = new Total(price);
    }
    Price.prototype.getTotal = function () {
        return this.total;
    };
    return Price;
}());
export { Price };
